import { accessRole } from "../../../../helpers/access_role";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { generateFormDataMultiple } from "../../../../helpers/ui/FileInput";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";
import IndexBloc from "../Index/Blocs/IndexBlock";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import Shimmer from "react-shimmer-effect";
import MinioClient from "../../../../services/minioClient";

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

var reformatSatkerOptions = (raw) => {
  if (!raw || !Array.isArray(raw)) {
    return [];
  }

  return raw.map((data) => ({
    label: `${data.kdsatker} - ${data.nmsatker}`,
    value: data.kdsatker,
  }));
};

var reformatBankSpanOptions = (raw) => {
  if (!raw || !Array.isArray(raw)) {
    return [];
  }

  return raw.map((data) => ({
    label: `${data.kdbankspan} - ${data.nmbankspan}`,
    value: data.kdbankspan,
  }));
};

var reformatReligionOptions = function (raw) {
  return raw.map(function (data) {
    return {
      label: `${data.religion_kemenkeu_code} - ${data.religion_name}`,
      value: data.religion_uuid,
      kode_kemenkeu: data.religion_kemenkeu_code,
      full_data: data,
    };
  });
};

class IndexView extends Component {
  updateBloc = new UpdateBloc();
  indexBloc = new IndexBloc();
  minioClient = new MinioClient();
  currentRoleId = JSON.parse(localStorage.getItem("currentRoleId"));

  // modal_confirm_status = 0
  modal_confirm_status_delete = 0;
  modal_confirm_message_delete = "";
  modal_confirm_sucess_message_delete = "data berhasil dihapus";
  modal_confirm_error_message_delete = "data gagal di dihapus";

  constructor(props) {
    super(props);
    this.state = {
      optionGender: [
        { label: "Laki-laki", value: "L" },
        { label: "Perempuan", value: "P" },
      ],
      birthOptionNationality: [
        { label: "Dalam Negeri", value: "Dalam Negeri" },
        { label: "Luar Negeri", value: "Luar Negeri" },
      ],
      birthOptionProvince: [],
      birthSelectedProvince: "",
      birthOptionCity: [],
      birthSelectedCity: "",
      birthOptionCountry: [],
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
      birthSelectedNational: "Dalam Negeri",
      isLocal: 1,
      //-------------------------------
      OptionReligion: [],
      OptionMaritalStatus: [],
      OptionBloodType: [],
      domicileOptionProvince: [],
      domicileOptionCity: [],
      domicileOptionDistrict: [],
      domicileOptionVillage: [],
      identityOptionProvince: [],
      identityOptionCity: [],
      identityOptionDistrict: [],
      identityOptionVillage: [],
      OptionBank: [],
      OptionUnit: [],
      OptionEmployeeType: [],
      OptionEmployeeStatus: [],
      OptionSallaryFrom: [
        { label: "Pusat", value: "Pusat" },
        { label: "Daerah", value: "Daerah" },
      ],
      OptionEmployeeStatusDesc: [],
      OptionEmployeeStatusPosition: [],
      dataForm: {},
      isDeath: 0,
      berkasItems: [],
      images: [{}],
      fotoabsen: [],
      deleteImageId: null,
      fotoprofile: "",
      birthSelectedCityText: "",
      religionSelected: "",
      religionKodeKemenkeu: "",
      employeeOption: [],
    };
  }

  setFotoAbsen = (service, index) => {
    this.minioClient.get(service.absent_image_file_path).then((url) => {
      this.setState({
        fotoabsen: [...this.state.fotoabsen, url],
      });
      // console.log(this.state.fotoabsen)
    });
  };

  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
        isLocal: 1,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        isLocal: 0,
      });
    }
  };

  handleSelectEmployeeStatus = (val) => {
    let selected = val.value;
    if (
      selected == "8b801490-0a8b-4479-bc40-a5d854759ddd" ||
      selected == "66041967-6060-4976-a255-fec889d9b077"
    ) {
      this.setState({
        isDeath: 1,
      });
    } else {
      this.setState({
        isDeath: 0,
      });
    }
  };

  handleBirthSelectCountry = (birthSelectedCountry) => {
    let selected = birthSelectedCountry.value;
    this.getBirthProvinceByCountry(selected);
  };

  getBirthProvinceByCountry(selected_uuid) {
    this.updateBloc.fetchRegionProvince({
      //is_local: 1,
      parent_uuid: selected_uuid,
      type: 2,
    });
  }

  // Start Select Area
  handleBirthSelectProvince = (birthSelectedProvince) => {
    let selected = birthSelectedProvince.value;
    this.getBirthCityByProvince(selected);
  };

  // get data city where province selected
  getBirthCityByProvince = (province_uuid) => {
    this.updateBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleBirthSelectCity = (birthSelectedCity) => {
    this.setState({
      birthSelectedCity: birthSelectedCity.value,
    });
  };

  handleDomicileSelectProvince = (domicileSelectedProvince) => {
    let selected = domicileSelectedProvince.value;
    this.getDomicileCityByProvince(selected);
  };

  // get data city where province selected
  getDomicileCityByProvince = (province_uuid) => {
    this.updateBloc.fetchDomicileCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleDomicileSelectCity = (domicileSelectedCity) => {
    let selected = domicileSelectedCity.value;
    this.getDomicileDistrictByCity(selected);
  };

  // get data district where city selected
  getDomicileDistrictByCity = (city_uuid) => {
    this.updateBloc.fetchDomicileDistrict({
      is_local: 1,
      type: 4,
      parent_uuid: city_uuid,
    });
  };

  handleDomicileSelectDistrict = (domicileSelectedDistrict) => {
    let selected = domicileSelectedDistrict.value;
    this.getDomicileVillageByDistrict(selected);
  };

  // get data village where district selected
  getDomicileVillageByDistrict = (district_uuid) => {
    this.updateBloc.fetchDomicileVillage({
      is_local: 1,
      type: 5,
      parent_uuid: district_uuid,
    });
  };

  // ---- Domicile x Identity

  handleIdentitySelectProvince = (identitySelectedProvince) => {
    let selected = identitySelectedProvince.value;
    this.getIdentityCityByProvince(selected);
  };

  // get data city where province selected
  getIdentityCityByProvince = (province_uuid) => {
    this.updateBloc.fetchIdentityCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleIdentitySelectCity = (identitySelectedCity) => {
    let selected = identitySelectedCity.value;
    this.getIdentityDistrictByCity(selected);
  };

  // get data district where city selected
  getIdentityDistrictByCity = (city_uuid) => {
    this.updateBloc.fetchIdentityDistrict({
      is_local: 1,
      type: 4,
      parent_uuid: city_uuid,
    });
  };

  handleIdentitySelectDistrict = (identitySelectedDistrict) => {
    let selected = identitySelectedDistrict.value;
    this.getIdentityVillageByDistrict(selected);
  };

  // get data village where district selected
  getIdentityVillageByDistrict = (district_uuid) => {
    this.updateBloc.fetchIdentityVillage({
      is_local: 1,
      type: 5,
      parent_uuid: district_uuid,
    });
  };

  // End Select Area

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, [
      "file",
      "photo",
      "photo_profile",
      "file_kk",
    ]); // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    // const formData = generateFormData(this.state.dataForm, ['file', 'photo']) // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.updateBloc.fetchUpdate(formData);
  };
  submitData__ = async () => {
    // this.state.dataForm["employee_uuid"] =  this.user.employee_uuid;

    const formData = generateFormDataMultiple(this.state.dataForm, {
      field: "photo",
      name: "photo",
      //   name: "ticketAttachments/attachment",
    });
    await this.updateBloc.fetchUpdate(formData);
  };

  handlerOnSubmit = (e, values) => {
    console.log(values);

    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.state.dataForm.employee_uuid,
        employee_current_position_uuid:
          this.state.dataForm.employee_current_position_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        console.log("confirm");
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  confirmResponseDelete = (response) => {
    let forStateDelete = {};
    switch (response) {
      case "cancel":
        forStateDelete = {
          confirm_delete: false,
        };
        break;
      case "confirm":
        forStateDelete = {
          loading_delete: true,
          confirm_delete: false,
        };
        let data_status = parseInt(this.modal_confirm_status_delete);
        if (data_status === 1) {
          this.inactiveData();
        }
        break;
      case "success":
        forStateDelete = {
          success_delete: false,
          // redirect: true
        };
        break;
      case "failed":
        forStateDelete = {
          failed_delete: false,
        };
        break;
      default:
    }
    this.setState(forStateDelete);
  };

  inactiveData = async () => {
    await this.updateBloc.fetchInactive({ fotoid: this.state.deleteImageId });
  };

  componentDidMount() {
    this.updateBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading_delete: false,
              success_delete: true,
              loadingTable_delete: true,
              fotoabsen: [],
            },
            function () {
              // this.setTokenAPI()
              // this.props.handleInactiveSuccess()
              let peg_uuid =
                JSON.parse(localStorage.getItem("userdata")) != null
                  ? JSON.parse(localStorage.getItem("userdata")).employee_uuid
                  : "";
              this.indexBloc.fetchImages({
                uuid: this.state.dataForm.employee_uuid,
              });
            },
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading_delete: false,
            failed_delete: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            // console.log('response')
            console.log(response);
            this.setState({
              dataForm: response,
            });
            this.updateBloc.fetchEmployee({
              nip: response.employee_nip,
            });
            this.minioClient
              .get(response.employee_image_file_path)
              .then((url) => {
                this.setState({
                  fotoprofile: url,
                });
                // console.log(url)
              });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    let peg_uuid =
      JSON.parse(localStorage.getItem("userdata")) != null
        ? JSON.parse(localStorage.getItem("userdata")).employee_uuid
        : "";
    if (accessRole("approve")) {
      peg_uuid =
        JSON.parse(localStorage.getItem("employeeSelected")) != null
          ? JSON.parse(localStorage.getItem("employeeSelected")).employee_uuid
          : "";
    }
    //const peg_uuid = "86e6f2af-1c9a-40c1-8845-594e2e3797b3";
    this.updateBloc.fetchDetail({ uuid: peg_uuid });

    // get data birth country
    this.updateBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCountry: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchRegionCountry({
      type: 1,
    });

    // get data province
    this.updateBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchRegionProvince({
      is_local: 1,
      type: 2,
    });

    // get city
    this.updateBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              birthOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getBirthCityByProvince(
      this.dataForm ? this.dataForm.employee_place_of_birth_province_uuid : "",
    );

    // get data religion
    this.updateBloc.religionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              OptionReligion: reformatReligionOptions(
                result.data.response.result,
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchReligion({});

    // get data marital status
    this.updateBloc.maritalStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionMaritalStatus: reformatOptions(
                response.result,
                "marital_status_name",
                "marital_status_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchMaritalStatus({});

    // CHANNEL ADDRESS START

    // get data province domicile
    this.updateBloc.domicileProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              domicileOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchDomicileProvince({
      is_local: 1,
      type: 2,
    });

    // get city domicile
    this.updateBloc.domicileCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getDomicileCityByProvince(
      this.dataForm ? this.dataForm.employee_domicile_province_uuid : "",
    );

    // get district domicile
    this.updateBloc.domicileDistrictChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionDistrict: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getDomicileDistrictByCity(
      this.dataForm ? this.dataForm.employee_domicile_city_uuid : "",
    );

    // get village domicile
    this.updateBloc.domicileVillageChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionVillage: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getDomicileVillageByDistrict(
      this.dataForm ? this.dataForm.employee_domicile_districts_uuid : "",
    );

    // get data province identity
    this.updateBloc.identityProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              identityOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchIdentityProvince({
      is_local: 1,
      type: 2,
    });

    // get city identity
    this.updateBloc.identityCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getIdentityCityByProvince(
      this.dataForm ? this.dataForm.employee_identity_province_uuid : "",
    );

    // get district identity
    this.updateBloc.identityDistrictChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionDistrict: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getIdentityDistrictByCity(
      this.dataForm ? this.dataForm.employee_identity_city_uuid : "",
    );

    // get village identity
    this.updateBloc.identityVillageChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionVillage: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getIdentityVillageByDistrict(
      this.dataForm ? this.dataForm.employee_identity_districts_uuid : "",
    );

    // CHANNEL ADDRESS END

    // get data blood type
    this.updateBloc.bloodTypeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionBloodType: reformatOptions(
                response.result,
                "blood_type_name",
                "blood_type_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchBloodType({});

    // get data bank
    this.updateBloc.bankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionBank: reformatOptions(
                response.result,
                "bank_name",
                "bank_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchBank({});

    // get data workunit
    this.updateBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionUnit: reformatOptions(
                response.result,
                "work_unit_name_tabs",
                "work_unit_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchWorkUnit({});

    // get data employee type
    this.updateBloc.employeeTypeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeType: reformatOptions(
                response.result,
                "employee_type_name",
                "employee_type_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchEmployeeType({});

    // get data employee status
    this.updateBloc.employeeStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeStatus: reformatOptions(
                response.result,
                "employee_status_name",
                "employee_status_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchEmployeeStatus({});

    // get data status desc
    this.updateBloc.employeeStatusDescriptionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeStatusDesc: reformatOptions(
                response.result,
                "employee_status_description_name",
                "employee_status_description_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchEmployeeStatusDescription({});

    // get data status desc
    this.updateBloc.employeeStatusPositionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeStatusPosition: reformatOptions(
                response.result,
                "employee_status_position_name",
                "employee_status_position_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchEmployeeStatusPosition({});

    this.indexBloc.imagesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              images: response,
            });
            this.state.images.map((data, index) => {
              this.setFotoAbsen(data, index);
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.indexBloc.fetchImages({ uuid: peg_uuid });

    this.updateBloc.satkerGajiWebChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const satkerData = result?.data?.response?.data?.decryptData;

          // set options first, then if employeeOption has kdsatker, compute selectedSatker
          const options = satkerData ? reformatSatkerOptions(satkerData) : [];

          this.setState({
            satkerGajiwebOption: options,
            loadingSatkerGajiWeb: false,
          });

          break;

        case apiResponse.ERROR:
          this.setState({
            loadingSatkerGajiWeb: false,
          });
          break;

        default:
          break;
      }
    });
    this.updateBloc.fetchSatkerGajiWeb();

    this.updateBloc.bankSpanGajiWebChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const bankSpanData = result?.data?.response?.data?.decryptData;

          // set options first, then if employeeOption has kdsatker, compute selectedSatker
          const options = bankSpanData
            ? reformatBankSpanOptions(bankSpanData)
            : [];

          this.setState({
            bankspanGajiwebOption: options,
            loadingBankSpanGajiWeb: false,
          });

          break;

        case apiResponse.ERROR:
          this.setState({
            loadingBankSpanGajiWeb: false,
          });
          break;

        default:
          break;
      }
    });
    this.updateBloc.fetchBankSpanGajiWeb();

    this.updateBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const employeeData = result?.data?.response?.data?.decryptData?.[0];

          this.setState({
            employeeOption: employeeData || {},
            loadingEmployee: false,
          });

          break;

        case apiResponse.ERROR:
          console.error("Employee Categories error:", result);
          this.setState({
            loadingEmployee: false,
          });
          break;

        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.updateBloc.updateChannel.unsubscribe();
    this.updateBloc.detailChannel.unsubscribe();
    this.updateBloc.regionCountryChannel.unsubscribe();
    this.updateBloc.regionProvinceChannel.unsubscribe();
    this.updateBloc.regionCityChannel.unsubscribe();
    this.updateBloc.religionChannel.unsubscribe();
    this.updateBloc.maritalStatusChannel.unsubscribe();
    this.updateBloc.domicileProvinceChannel.unsubscribe();
    this.updateBloc.domicileCityChannel.unsubscribe();
    this.updateBloc.domicileDistrictChannel.unsubscribe();
    this.updateBloc.domicileVillageChannel.unsubscribe();
    this.updateBloc.identityProvinceChannel.unsubscribe();
    this.updateBloc.identityCityChannel.unsubscribe();
    this.updateBloc.identityDistrictChannel.unsubscribe();
    this.updateBloc.identityVillageChannel.unsubscribe();
    this.updateBloc.bloodTypeChannel.unsubscribe();
    this.updateBloc.bankChannel.unsubscribe();
    this.updateBloc.workUnitChannel.unsubscribe();
    this.updateBloc.employeeTypeChannel.unsubscribe();
    this.updateBloc.employeeStatusChannel.unsubscribe();
    this.updateBloc.employeeStatusDescriptionChannel.unsubscribe();
    this.updateBloc.employeeStatusPositionChannel.unsubscribe();
    this.updateBloc.satkerGajiWebChannel.unsubscribe();
    this.updateBloc.bankSpanGajiWebChannel.unsubscribe();
    this.updateBloc.employeeChannel.unsubscribe();
  }

  render() {
    console.log(this.state.dataForm);
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="identitas" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Edit Identitas</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Foto Profile
                      </label>
                      <Col md="6">
                        <table className="table">
                          <tbody>
                            <tr>
                              {this.state.dataForm.employee_image_isminio ==
                              null ? (
                                <>
                                  <img
                                    src={
                                      this.state.dataForm
                                        .employee_image_file_baseurl +
                                      "/" +
                                      this.state.dataForm
                                        .employee_image_file_path
                                    }
                                    alt=""
                                    className="avatar-lg img-thumbnail"
                                    style={{ marginRight: "10px" }}
                                  />{" "}
                                  <br />
                                </>
                              ) : this.state.dataForm
                                  .employee_image_file_path ? (
                                <>
                                  <img
                                    src={this.state.fotoprofile}
                                    alt=""
                                    className="avatar-lg img-thumbnail"
                                    style={{ marginRight: "10px" }}
                                  />{" "}
                                  <br />
                                </>
                              ) : (
                                <Shimmer>
                                  <div
                                    style={{ width: "50%", height: 15 }}
                                  ></div>
                                </Shimmer>
                              )}
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload Foto Profile
                      </Label>
                      <Col md="4">
                        <FileInput
                          name="photo_profile"
                          accept=".jpg,.png,.jpeg"
                          isMultiple={true}
                          maxFiles={1}
                        />
                        <p
                          style={{ fontWeight: 500 }}
                          className="text-secondary"
                        >
                          Format file yang diijinkan: .jpg, .png, .jpeg
                        </p>
                        <p className="text-secondary">*Maksimal 1 files.</p>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Foto Absen
                      </label>
                      <Col md="6">
                        <table className="table">
                          <tbody>
                            <tr>
                              {this.state.fotoabsen ? (
                                <>
                                  {this.state.fotoabsen.map((data, index) => {
                                    return (
                                      <td>
                                        <img
                                          src={data}
                                          alt=""
                                          className="avatar-lg img-thumbnail"
                                          style={{ marginRight: "10px" }}
                                        />{" "}
                                        <br />
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-danger"
                                          onClick={() => {
                                            this.modal_confirm_status_delete = 1;
                                            this.modal_confirm_message_delete =
                                              "Apakah anda yakin akan menghapus foto ini ?";
                                            this.setState({
                                              deleteImageId:
                                                this.state.images[index]
                                                  .absent_image_id,
                                              confirm_delete: true,
                                            });
                                            // alert(this.state.images[index].absent_image_id)
                                          }}
                                        >
                                          <i class="uil-trash-alt"></i>
                                        </button>
                                      </td>
                                    );
                                  })}
                                </>
                              ) : (
                                <Shimmer>
                                  <div
                                    style={{ width: "50%", height: 15 }}
                                  ></div>
                                </Shimmer>
                              )}
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload Foto{" "}
                      </Label>
                      <Col md="4">
                        {/* <FileInput
                                                    name="photo"
                                                    col="6"
                                                />  */}
                        <FileInput
                          name="photo"
                          accept=".jpg,.png,.jpeg"
                          isMultiple={true}
                          maxFiles={5}
                        />
                        <p
                          style={{ fontWeight: 500 }}
                          className="text-secondary"
                        >
                          Format file yang diijinkan: .jpg, .png, .jpeg
                        </p>
                        <p className="text-secondary">*Maksimal 5 files.</p>
                        {/* ini ditutup dulu */}
                        {/* <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : ' '}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                    }
                                                </div> */}
                      </Col>
                      {/* lanjutan dari foto */}
                    </Row>

                    {/* <Row className="mb-3">
                      <label htmlFor="kat" className="col-md-3 col-form-label">
                        Satker <span className="text-danger"></span>
                      </label>

                      <Col md="5">
                        <CustomSelect
                          name="employee_satker_code"
                          errorMessage="Pilih Satker"
                          onChange={(opt) =>
                            this.setState((prev) => ({
                              employeeOption: {
                                ...(prev.employeeOption || {}),
                                kdsatker: opt?.value,
                              },
                              selectedSatker: opt || null,
                            }))
                          }
                          options={this.state.satkerGajiwebOption}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Satker"
                        />
                        <AvField
                          type="hidden"
                          name="employee_satker_code"
                          value={this.state.employeeOption?.kdsatker}
                        />
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        NIP Lama
                      </label>
                      <Col md="3">
                        <AvField
                          name="employee_nip_old"
                          placeholder="NIP..."
                          type="text"
                          errorMessage="Masukkan NIP"
                          className="form-control"
                          validate={{ required: { value: false } }}
                          id="employee_nip_old"
                          value={this.state.dataForm.employee_nip_old}
                          disabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        NIP Baru <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_nip"
                          placeholder="NIP..."
                          type="text"
                          errorMessage="Masukkan NIP"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="employee_nip"
                          value={this.state.dataForm.employee_nip}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Nama <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_name"
                          placeholder="Nama..."
                          type="text"
                          errorMessage="Masukkan Nama"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="employee_name"
                          value={this.state.dataForm.employee_name}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 hidden">
                      <label className="col-md-3 col-form-label">
                        Gelar Non Akademi Depan
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_front_title_non_academic"
                          placeholder="Gelar Non Akademi Depan..."
                          type="text"
                          errorMessage="Masukkan Gelar Non Akademi Depan"
                          className="form-control"
                          id="employee_front_title_non_academic"
                          value={
                            this.state.dataForm
                              .employee_front_title_non_academic
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 hidden">
                      <label className="col-md-3 col-form-label">
                        Gelar Non Akadami Belakang
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_end_title_non_academic"
                          placeholder="Gelar Non Akadami Belakang..."
                          type="text"
                          errorMessage="Masukkan Gelar Non Akadami Belakang"
                          className="form-control"
                          id="employee_end_title_non_academic"
                          value={
                            this.state.dataForm.employee_end_title_non_academic
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Gelar Depan
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_front_title"
                          placeholder="Gelar Depan..."
                          type="text"
                          errorMessage="Masukkan Gelar Depan"
                          className="form-control"
                          id="employee_front_title"
                          value={this.state.dataForm.employee_front_title}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Gelar Belakang
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_end_title"
                          placeholder="Gelar Belakang..."
                          type="text"
                          errorMessage="Masukkan Gelar Belakang"
                          className="form-control"
                          id="employee_end_title"
                          value={this.state.dataForm.employee_end_title}
                        />
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col md="5">
                        <label className="fw-bold">#Tempat Lahir</label>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Dalam / Luar Negeri
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_place_of_birth_national"
                          errorMessage="Pilih Dalam / Luar Negeri Lahir"
                          onChange={this.handleBirthSelectNationality}
                          options={this.state.birthOptionNationality}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Dalam / Luar Negeri Lahir"
                          defaultValue={this.state.birthSelectedNational}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Negara
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_place_of_birth_country_uuid"
                          errorMessage="Pilih Negara Lahir"
                          onChange={this.handleBirthSelectCountry}
                          options={this.state.birthOptionCountry}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Negara Lahir"
                          defaultValue={this.state.birthSelectedCountry}
                          isDisabled={this.state.isLocal == 0 ? false : true}
                        />
                      </Col>
                    </Row>
                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label className="col-md-3 col-form-label">
                        Provinsi Lahir
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_place_of_birth_province_uuid"
                          errorMessage="Pilih Provinsi Lahir"
                          onChange={this.handleBirthSelectProvince}
                          options={this.state.birthOptionProvince}
                          // validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                          placeholder="Pilih Provinsi Lahir"
                          defaultValue={
                            this.state.dataForm
                              .employee_place_of_birth_province_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label className="col-md-3 col-form-label">
                        Kota Lahir
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_place_of_birth_city_uuid"
                          errorMessage="Pilih Kota Lahir"
                          options={this.state.birthOptionCity}
                          // validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                          placeholder="Pilih Kota Lahir"
                          defaultValue={
                            this.state.dataForm
                              .employee_place_of_birth_city_uuid
                          }
                          onChange={(v) =>
                            this.setState({
                              birthSelectedCity: v.value,
                              birthSelectedCityText: v.label,
                            })
                          }
                        />

                        <AvField
                          type="hidden"
                          name="employee_place_of_birth_city_text"
                          value={
                            this.state.birthSelectedCityText ||
                            this.state.dataForm
                              .employee_place_of_birth_city_text
                          }
                        />
                      </Col>
                    </Row>
                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 1 ? { display: "none" } : {}}
                    >
                      <label
                        htmlFor="employee_place_of_birth_city_text"
                        className="col-md-3 col-form-label"
                      >
                        Kota Lahir
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_place_of_birth_city_text"
                          placeholder="Kota..."
                          type="text"
                          errorMessage="Masukkan Kota"
                          className="form-control"
                          // validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                          id="employee_place_of_birth_city_text"
                          value={
                            this.state.dataForm
                              .employee_place_of_birth_city_text
                          }
                        />
                      </Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Tanggal Lahir
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="3">
                        <AvField
                          name="employee_date_of_birth"
                          placeholder="Tanggal Lahir..."
                          type="date"
                          errorMessage="Masukkan Tanggal Lahir"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_date_of_birth"
                          value={this.state.dataForm.employee_date_of_birth}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Jenis Kelamin
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name="employee_gender"
                          errorMessage="Pilih Jenis Kelamin"
                          options={this.state.optionGender}
                          placeholder="Pilih Jenis Kelamin"
                          defaultValue={this.state.dataForm.employee_gender}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Agama
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name="employee_religion_uuid"
                          errorMessage="Pilih Agama"
                          options={this.state.OptionReligion}
                          placeholder="Pilih Agama"
                          defaultValue={
                            this.state.dataForm.employee_religion_uuid
                          }
                          onChange={(v) =>
                            this.setState({
                              religionSelected: v.value,
                              religionKodeKemenkeu: v.kode_kemenkeu,
                            })
                          }
                        />
                        <AvField
                          type="hidden"
                          name="employee_religion_kode_kemenkeu"
                          value={
                            this.state.religionKodeKemenkeu ||
                            this.state.employeeOption?.kdagama
                          }
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Status Pernikahan
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="employee_marital_status_uuid"
                          errorMessage="Pilih Status Pernikahan"
                          options={this.state.OptionMaritalStatus}
                          placeholder="Pilih Status Pernikahan"
                          defaultValue={
                            this.state.dataForm.employee_marital_status_uuid
                          }
                        />
                      </Col>
                    </Row> */}
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Golongan Darah
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="employee_blood_type_uuid"
                          errorMessage="Pilih Golongan Darah"
                          options={this.state.OptionBloodType}
                          placeholder="Pilih Golongan Darah"
                          defaultValue={
                            this.state.dataForm.employee_blood_type_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Alamat Tinggal
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="9">
                        <AvField
                          name="employee_domicile_address"
                          placeholder="Alamat Tinggal..."
                          type="textarea"
                          errorMessage="Masukkan Alamat Tinggal"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_domicile_address"
                          value={this.state.dataForm.employee_domicile_address}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Provinsi
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_domicile_province_uuid"
                          errorMessage="Pilih Provinsi"
                          onChange={this.handleDomicileSelectProvince}
                          options={this.state.domicileOptionProvince}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Provinsi"
                          defaultValue={
                            this.state.dataForm.employee_domicile_province_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kota/Kabupaten
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_domicile_city_uuid"
                          errorMessage="Pilih Kota"
                          onChange={this.handleDomicileSelectCity}
                          options={this.state.domicileOptionCity}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Kota"
                          defaultValue={
                            this.state.dataForm.employee_domicile_city_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kecamatan
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_domicile_districts_uuid"
                          errorMessage="Pilih Kecamatan"
                          onChange={this.handleDomicileSelectDistrict}
                          options={this.state.domicileOptionDistrict}
                          placeholder="Pilih Kecamatan"
                          defaultValue={
                            this.state.dataForm.employee_domicile_districts_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Desa/Kelurahan
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_domicile_village_uuid"
                          errorMessage="Desa/Kelurahan"
                          options={this.state.domicileOptionVillage}
                          placeholder="Desa/Kelurahan"
                          defaultValue={
                            this.state.dataForm.employee_domicile_village_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kode Pos
                      </label>
                      <Col md="3">
                        <AvField
                          name="employee_domicile_postal_code"
                          placeholder="Kode Pos..."
                          type="number"
                          errorMessage="Masukkan Kode Pos"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_domicile_postal_code"
                          value={
                            this.state.dataForm.employee_domicile_postal_code
                          }
                        />
                      </Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Alamat KTP
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="9">
                        <AvField
                          name="employee_identity_address"
                          placeholder="Alamat KTP..."
                          type="textarea"
                          errorMessage="Masukkan Alamat KTP"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_identity_address"
                          value={this.state.dataForm.employee_identity_address}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Provinsi
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_identity_province_uuid"
                          errorMessage="Pilih Provinsi"
                          onChange={this.handleIdentitySelectProvince}
                          options={this.state.identityOptionProvince}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Provinsi"
                          defaultValue={
                            this.state.dataForm.employee_identity_province_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kota/Kabupaten
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_identity_city_uuid"
                          errorMessage="Pilih Kota"
                          onChange={this.handleIdentitySelectCity}
                          options={this.state.identityOptionCity}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Kota"
                          defaultValue={
                            this.state.dataForm.employee_identity_city_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kecamatan
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_identity_districts_uuid"
                          errorMessage="Pilih Kecamatan"
                          onChange={this.handleIdentitySelectDistrict}
                          options={this.state.identityOptionDistrict}
                          placeholder="Pilih Kecamatan"
                          defaultValue={
                            this.state.dataForm.employee_identity_districts_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Desa/Kelurahan
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_identity_village_uuid"
                          errorMessage="Desa/Kelurahan"
                          options={this.state.identityOptionVillage}
                          placeholder="Desa/Kelurahan"
                          defaultValue={
                            this.state.dataForm.employee_identity_village_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kode Pos
                      </label>
                      <Col md="3">
                        <AvField
                          name="employee_identity_postal_code"
                          placeholder="Kode Pos..."
                          type="number"
                          errorMessage="Masukkan Kode Pos"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_identity_postal_code"
                          value={
                            this.state.dataForm.employee_identity_postal_code
                          }
                        />
                      </Col>
                    </Row>

                    <hr />

                    {/* Administrator  */}
                    {/* {this.currentRoleId == 1 ? (
                      <>
                        <Row className="mb-3">
                          <label className="col-md-3 col-form-label">
                            Rekening Gaji
                          </label>
                          <Col md="5">
                            <AvField
                              name="employee_bank_account_number"
                              placeholder="Rekening Gaji"
                              type="number"
                              errorMessage="Masukkan Rekening Gaji"
                              className="form-control"
                              id="employee_bank_account_number"
                              value={
                                this.state.dataForm.employee_bank_account_number
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <label className="col-md-3 col-form-label">
                            Nama Pemilik Rekening
                          </label>
                          <Col md="5">
                            <AvField
                              name="employee_bank_account_name"
                              placeholder="Nama Pemilik Rekening..."
                              type="text"
                              errorMessage="Masukkan Nama Pemilik Rekening"
                              className="form-control"
                              id="employee_bank_account_name"
                              value={
                                this.state.dataForm.employee_bank_account_name
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <label className="col-md-3 col-form-label">
                            Bank
                          </label>
                          <Col md="5">
                            <CustomSelect
                              name="employee_bank_uuid"
                              errorMessage="Pilih Bank"
                              options={this.state.OptionBank}
                              placeholder="Pilih Bank..."
                              defaultValue={
                                this.state.dataForm.employee_bank_uuid
                              }
                            />
                          </Col>
                        </Row>
                      </>
                    ) : null} */}

                    {/* Pegawai  */}
                    {/* {this.currentRoleId == 2 ? (
                      <>
                        <Row className="mb-3">
                          <label className="col-md-3">Rekening Gaji</label>
                          <Col md="5">
                            {this.state.dataForm
                              .employee_bank_account_number !== ""
                              ? this.state.dataForm.employee_bank_account_number
                              : "-"}
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label className="col-md-3">
                            Nama Pemilik Rekening
                          </label>
                          <Col md="5">
                            {this.state.dataForm.employee_bank_account_name !==
                            ""
                              ? this.state.dataForm.employee_bank_account_name
                              : "-"}
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label className="col-md-3">Bank</label>
                          <Col md="5">
                            {this.state.dataForm.employee_bank_name !== ""
                              ? this.state.dataForm.employee_bank_name
                              : "-"}
                          </Col>
                        </Row>
                      </>
                    ) : null} */}

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Unit Kerja <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_current_work_unit_uuid"
                          errorMessage="Pilih Unit Kerja"
                          options={this.state.OptionUnit}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Unit Kerja..."
                          defaultValue={
                            this.state.dataForm.employee_current_work_unit_uuid
                          }
                          isDisabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Tipe Pegawai
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_type_uuid"
                          errorMessage="Pilih Tipe Pegawai"
                          options={this.state.OptionEmployeeType}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Tipe Pegawai..."
                          defaultValue={this.state.dataForm.employee_type_uuid}
                          isDisabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Status Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_status_uuid"
                          errorMessage="Pilih Status Pegawai"
                          options={this.state.OptionEmployeeStatus}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status Pegawai..."
                          defaultValue={
                            this.state.dataForm.employee_status_uuid
                          }
                          onChange={this.handleSelectEmployeeStatus}
                          isDisabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Honorer <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_honorer"
                          errorMessage="Pilih Honorer"
                          options={[
                            { label: "Ya", value: 1 },
                            { label: "Tidak", value: 2 },
                          ]}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Honorer..."
                          defaultValue={this.state.employeeOption?.honorer}
                          onChange={this.handleSelectEmployeeStatus}
                          isDisabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row> */}
                    <Row
                      className="mb-3"
                      style={this.state.isDeath == 0 ? { display: "none" } : {}}
                    >
                      <label className="col-md-3 col-form-label">
                        Tanggal Meninggal
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_date_of_death"
                          placeholder="Tanggal Meninggal..."
                          type="date"
                          errorMessage="Masukkan Tanggal Meninggal"
                          className="form-control"
                          id="employee_date_of_death"
                          value={this.state.dataForm.employee_date_of_death}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Status Penggajian <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_salary_paid_from"
                          errorMessage="Pilih Status Penggajian"
                          options={this.state.OptionSallaryFrom}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status Penggajian..."
                          defaultValue={
                            this.state.dataForm.employee_salary_paid_from
                          }
                          isDisabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Keterangan Status
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_status_description_uuid"
                          errorMessage="Pilih Keterangan Status"
                          options={this.state.OptionEmployeeStatusDesc}
                          // validate={{ required: { value: true } }}
                          placeholder="Pilih Keterangan Status..."
                          defaultValue={
                            this.state.dataForm.employee_status_description_uuid
                          }
                          isDisabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Tanggal Pensiun
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_date_of_pension"
                          placeholder="Tanggal Pensiun..."
                          type="date"
                          errorMessage="Masukkan Tanggal Pensiun"
                          className="form-control"
                          id="employee_date_of_pension"
                          value={this.state.dataForm.employee_date_of_pension}
                          disabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        TMT Pensiun
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_tmt_pension"
                          placeholder="TMT Pensiun..."
                          type="date"
                          errorMessage="Masukkan TMT Pensiun"
                          className="form-control"
                          id="employee_tmt_pension"
                          value={this.state.dataForm.employee_tmt_pension}
                          disabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kedudukan <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="employee_status_position_uuid"
                          errorMessage="Pilih Kedudukan"
                          options={this.state.OptionEmployeeStatusPosition}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Kedudukan..."
                          defaultValue={
                            this.state.dataForm.employee_status_position_uuid
                          }
                          isDisabled={this.currentRoleId == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Kartu Pegawai
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_karpeg_number"
                          placeholder="Kartu Pegawai..."
                          type="text"
                          errorMessage="Masukkan Kartu Pegawai"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_karpeg_number"
                          value={this.state.dataForm.employee_karpeg_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Askes / BPJS Kesehatan
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_askes_number"
                          placeholder="Askes / BPJS Kesehatan..."
                          type="text"
                          errorMessage="Masukkan Askes / BPJS Kesehatan"
                          className="form-control"
                          id="employee_askes_number"
                          value={this.state.dataForm.employee_askes_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">Tapera</label>
                      <Col md="5">
                        <AvField
                          name="employee_tapera_number"
                          placeholder="Tapera..."
                          type="text"
                          errorMessage="Masukkan Tapera"
                          className="form-control"
                          id="employee_tapera_number"
                          value={this.state.dataForm.employee_tapera_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">Taspen</label>
                      <Col md="5">
                        <AvField
                          name="employee_taspen_number"
                          placeholder="Taspen..."
                          type="text"
                          errorMessage="Masukkan Taspen"
                          className="form-control"
                          id="employee_taspen_number"
                          value={this.state.dataForm.employee_taspen_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">NPWP</label>
                      <Col md="5">
                        <AvField
                          name="employee_npwp_number"
                          placeholder="NPWP..."
                          type="text"
                          errorMessage="Masukkan NPWP"
                          className="form-control"
                          id="employee_npwp_number"
                          value={this.state.dataForm.employee_npwp_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        NIK
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_identity_number"
                          placeholder="NIK..."
                          type="text"
                          errorMessage="Masukkan NIK"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_identity_number"
                          value={this.state.dataForm.employee_identity_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 hidden">
                      <label className="col-md-3 col-form-label">
                        Nomor Dosir
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_dosir_number"
                          placeholder="Nomor Dosir..."
                          type="text"
                          errorMessage="Masukkan Nomor Dosir"
                          className="form-control"
                          id="employee_dosir_number"
                          value={this.state.dataForm.employee_dosir_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Telepon Rumah
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_phone_number"
                          placeholder="Telepon Rumah..."
                          type="text"
                          errorMessage="Masukkan Telepon Rumah"
                          className="form-control"
                          id="employee_phone_number"
                          value={this.state.dataForm.employee_phone_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Handphone
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_mobile_phone_number"
                          placeholder="Handphone..."
                          type="number"
                          errorMessage="Masukkan Handphone"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="employee_mobile_phone_number"
                          value={
                            this.state.dataForm.employee_mobile_phone_number
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Email Office 365 <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_email_internal"
                          placeholder="Email..."
                          type="email"
                          errorMessage="Masukkan Email"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="employee_email_internal"
                          value={this.state.dataForm.employee_email_internal}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Email Eksternal <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_email_external"
                          placeholder="Email..."
                          type="email"
                          errorMessage="Masukkan Email"
                          className="form-control"
                          id="employee_email_external"
                          value={this.state.dataForm.employee_email_external}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Enroll Number <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <AvField
                          name="enrol_number"
                          placeholder="Enroll Number..."
                          type="text"
                          errorMessage="Masukkan Enroll Number"
                          className="form-control"
                          id="enrol_number"
                          value={this.state.dataForm.employee_enroll_number}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        ID SAPK BKN
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_sapk_bkn_id"
                          placeholder="ID SAPK BKN..."
                          type="text"
                          errorMessage="Masukkan ID SAPK BKN"
                          className="form-control"
                          id="employee_sapk_bkn_id"
                          value={this.state.dataForm.employee_sapk_bkn_id}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Pendukung{" "}
                      </Label>
                      <Col md="8">
                        <FileInput name="file" col="6" />
                        <div className="mt-2">
                          {this.state.dataForm ? (
                            <>
                              {this.state.dataForm.document !== null ? (
                                <a
                                  target={"_blank"}
                                  className="btn btn-sm btn-success"
                                  href={
                                    this.state.dataForm.document?.documents_path
                                  }
                                >
                                  Download File Sebelumnya{" "}
                                  <i className="fa fa-download ms-1"></i>
                                </a>
                              ) : (
                                " "
                              )}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "50%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </div>
                      </Col>
                    </Row>

                    {/* Penambahan KK */}
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Nomor Kartu Keluarga{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <AvField
                          name="employee_family_card_number"
                          placeholder="Nomor Kartu Keluarga..."
                          type="text"
                          required
                          errorMessage="Masukkan Nomor Kartu Keluarga"
                          className="form-control"
                          id="employee_family_card_number"
                          value={
                            this.state.dataForm.employee_family_card_number
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Kartu Keluarga{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="8">
                        <FileInput name="file_kk" col="6" required />
                        <div className="mt-2">
                          {this.state.dataForm ? (
                            <>
                              {this.state.dataForm.document_kk !== null ? (
                                <a
                                  target={"_blank"}
                                  className="btn btn-sm btn-success"
                                  href={
                                    this.state.dataForm.document_kk
                                      ?.documents_path
                                  }
                                >
                                  Download File Sebelumnya{" "}
                                  <i className="fa fa-download ms-1"></i>
                                </a>
                              ) : (
                                " "
                              )}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "50%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <div className="form-check form-switch mb-3">
                          <AvCheckboxGroup
                            name="checkboxExample"
                            required
                            errorMessage="Agreement harus di centang"
                          >
                            <AvCheckbox
                              label="Saya yakin dan bertanggung jawab atas data ini"
                              value="1"
                            />
                          </AvCheckboxGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/home.html?identitas">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <AvField
                        type="hidden"
                        name="employee_categories_bank_name"
                        value={this.state.employeeOption?.nm_bank}
                      />
                      <AvField
                        type="hidden"
                        name="employee_bank_account_number"
                        value={this.state.employeeOption?.rekening}
                      />
                      <AvField
                        type="hidden"
                        name="employee_bank_account_name"
                        value={this.state.employeeOption?.nmrek}
                      />
                      <AvField
                        type="hidden"
                        name="employee_bankspan_code"
                        value={this.state.employeeOption?.kdbankspan}
                      />
                      <AvField
                        type="hidden"
                        name="employee_categories_kode_kemenkeu"
                        value={this.state.employeeOption?.jpns}
                      />
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message_delete}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message_delete}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message_delete}
          showConfirm={this.state.confirm_delete}
          showLoading={this.state.loading_delete}
          showSuccess={this.state.success_delete}
          showFailed={this.state.failed_delete}
          response={this.confirmResponseDelete}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?identitas" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
